import React, { Component } from "react";
import UserAddCase from "./UserAddCase";
import UserEmpty from "./UserEmpty";
import CaseCardList from "../../../components/PostsList/components/CaseCardList";
import PostsList from "../../../components/PostsList";

class UserPosts extends Component {
  componentDidMount() {
    this.props.isSSRUser && this.props.loadMorePosts({ override: true });
  }

  render() {
    const { posts, user, loadMorePosts, isOwnProfile } = this.props;

    return <PostsList
      posts={posts}
      NotFoundComponent={isOwnProfile ? <UserAddCase /> : <UserEmpty username={user.name} />}
      loadMorePosts={loadMorePosts}
      CaseListComponent={CaseCardList}
    />
  }
}

export default UserPosts;


// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/UserPosts.js